<template>
  <a-form layout="vertical" :model="formState" ref="formRef">
    <DisabledContainer :isDisabled="disabled" v-if="node?.type != NodeType.OptionConsultApi">
      <a-form-item
        label="Selecciona el número o símbolo"
        name="option"
        :rules="[{ required: true, message: 'Por favor ingresar el número o símbolo' }]"
      >
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          v-model:value="formState.option"
          placeholder="Número o símbolo"
        >
          <a-select-option
            v-for="option in numericalOptions"
            :key="option"
            :value="option"
            :disabled="parentNode?.child.find((child) => child.option === option)"
          >
            {{ option }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </DisabledContainer>
    <ActionPicker
      v-if="node"
      :node="node"
      :parentNode="parentNode"
      isNumericDefaultOption
      :disabled="disabled"
    />
  </a-form>
</template>

<script setup lang="ts">
import { provide, reactive, ref } from "vue";
import { FormInstance } from "ant-design-vue";

import DisabledContainer from "@/app/shared/components/molecules/DisabledContainer.vue";
import { CreateNodeBody, Node } from "@/@types/ivr";
import { DrawerFormStateKey } from "@/@types/ivr/symbols";
import { numericalOptions } from "@/app/ivr/bot/utils/texts";

import ActionPicker from "@/app/ivr/bot/components/pickers/ActionPicker.vue";
import { ActionType, NodeType } from "../../../utils/enums";

const props = defineProps<{
  node?: Node;
  parentNode?: Node;
  disabled?: boolean;
}>();

const formRef = ref<FormInstance>();
const formState = reactive<Partial<CreateNodeBody>>({
  option: props.node?.option,
  action: props.node?.action,
});

provide(DrawerFormStateKey, formState);

defineExpose({ formState, formRef });
</script>

<style scoped lang="sass"></style>
